import * as THREE from 'three';
import { makeFixedWindow } from '../scene/fixedWindows';
import { runMeasurements } from './runMeasurements';
import { applyMetricUVs } from '../scene/materialGeometry';
import { makeShapedFixedWindow } from './fixedShapeModel';
import { addFixedGrilles } from './fixedWindowGrilles';

function makeRun(design, product, materials, frame, side) {
  const run = design[`run_${side}`], corner = design.layout === 'corner';
  const width = run.width_in * .0254, height = design.height_in * .0254, shape = design.window_shape || 'rectangle';
  const sized = { ...product, width, height };
  const original = shape === 'rectangle' ? makeFixedWindow(sized, { ...materials, makeFrame: () => frame }, { cornerSide: corner ? side : null }) : makeShapedFixedWindow(sized, materials, frame, shape);
  const { group } = original;
  addFixedGrilles(group, { ...design, run_a: run }, frame);
  const measures = runMeasurements(width, height, run.width_in, corner, side);
  group.add(measures);
  group.userData.panelPositions = [{ x: 0, z: 0 }];
  group.userData.dividers = design.dividers;
  return { group, measures, animate: () => {}, screen: null, width, height, panelWidth: width, count: 1, tracks: 0, depth: group.userData.sourceProfileDepth / 1000, side };
}

export function makeFixedWindowReplacement(design, product, materials, frame) {
  const a = makeRun(design, product, materials, frame, 'a'), runs = [a], group = new THREE.Group();
  group.userData.fixed = true; group.add(a.group);
  if (design.layout === 'corner') {
    const b = makeRun(design, product, materials, frame, 'b'); runs.push(b); group.add(b.group);
    a.group.position.x = -a.width / 2;
    b.group.rotation.y = Math.PI / 2; b.group.position.z = b.width / 2;
    group.userData.cornerConnection = 'glass-to-glass';
    group.userData.cornerMeetingGap = Math.SQRT2 * .001;
  }
  applyMetricUVs(group);
  return { group, runs };
}